import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import PersonalContent from "./PersonalContent";
import ProgressBar from "../../../components/ProgressBar";
import _get from "lodash/get";

export class DriverRegRequirementContainer extends React.Component {
    render() {
        return (
            <div>
                <Row>
                    <Col xs="12">
                        <ProgressBar percentage={10} />
                    </Col>
                    <Col xs="12">
                        <PersonalContent />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        business: _get(state, "appData.business", {})
    };
};
export default withRouter(
    connect(
        mapStateToProps,
        {}
    )(DriverRegRequirementContainer)
);
